import { createGtm } from '@gtm-support/vue-gtm'

import { GTM } from './gtm.class'
import { getGtmConfig } from './plugin.utils'

const getGtm = () => {
  const gtm = new GTM()

  return {
    create: gtm.create.bind(gtm),
    push: gtm.push.bind(gtm),
  }
}

export default defineNuxtPlugin(({ vueApp }) => {
  const { id } = getGtmConfig()

  vueApp.use(
    createGtm({
      id,

      // Такие параметры установлены для того, чтоб подключить плагин Vue, но подключить скрипт только тогда, когда будет инициализация GTM
      loadScript: true,
      enabled: false,
    })
  )

  const gtm = getGtm()

  return {
    provide: {
      gtm,
    },
  }
})
